import { TFunction } from 'react-i18next';
import { ValidationOperator, OptionSelectionCount } from './questionValidationRules.types';

export interface OperatorConfig {
  value: ValidationOperator;
  label: string;
  description?: string;
  requiresMinCount?: boolean;
  minSelectionCount?: number | 'any';
  availableWhen?: (selectionCount: OptionSelectionCount) => boolean;
}

export const OPERATOR_CONFIGS: (t: TFunction<'questionnaireTemplate'>) => OperatorConfig[] = (
  t: TFunction<'questionnaireTemplate'>,
) => [
  {
    value: ValidationOperator.IS_EQUAL,
    label: t('formBuilder.canvas.element.validationRules.operator.IS_EQUAL.label'),
    description: t('formBuilder.canvas.element.validationRules.operator.IS_EQUAL.description'),
    requiresMinCount: false,
    minSelectionCount: 1,
  },
  {
    value: ValidationOperator.HAS_ANSWER,
    label: t('formBuilder.canvas.element.validationRules.operator.HAS_ANSWER.label'),
    description: t('formBuilder.canvas.element.validationRules.operator.HAS_ANSWER.description'),
    requiresMinCount: false,
    minSelectionCount: 1,
    availableWhen: (selectionCount) => selectionCount === 'any' || selectionCount > 1,
  },
  {
    value: ValidationOperator.DOES_NOT_HAVE_ANSWER,
    label: t('formBuilder.canvas.element.validationRules.operator.DOES_NOT_HAVE_ANSWER.label'),
    description: t('formBuilder.canvas.element.validationRules.operator.DOES_NOT_HAVE_ANSWER.description'),
    requiresMinCount: false,
    minSelectionCount: 1,
  },
  {
    value: ValidationOperator.AT_LEAST,
    label: t('formBuilder.canvas.element.validationRules.operator.AT_LEAST.label'),
    description: t('formBuilder.canvas.element.validationRules.operator.AT_LEAST.description'),
    requiresMinCount: true,
    minSelectionCount: 1,
  },
];
